var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.796 0h-11.889c-5.548 0-9.907 4.359-9.907 9.907v11.889c0 5.548 4.359 9.907 9.907 9.907h11.889c5.548 0 9.907-4.359 9.907-9.907v-11.889c0-5.548-4.359-9.907-9.907-9.907zM28.731 21.796c0 3.765-3.17 6.935-6.935 6.935h-11.889c-3.765 0-6.935-3.17-6.935-6.935v-11.889c0-3.963 3.17-6.935 6.935-6.935h11.889c3.765 0 6.935 3.17 6.935 6.935v11.889z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.852 7.928c-4.359 0-7.926 3.567-7.926 7.926s3.567 7.926 7.926 7.926c4.359 0 7.926-3.567 7.926-7.926s-3.566-7.926-7.926-7.926zM15.852 20.807c-2.774 0-4.953-2.18-4.953-4.954s2.18-4.954 4.953-4.954c2.774 0 4.954 2.18 4.954 4.954s-2.18 4.954-4.954 4.954z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.371 8.324c0.547 0 0.991-0.444 0.991-0.991s-0.444-0.991-0.991-0.991c-0.547 0-0.991 0.444-0.991 0.991s0.444 0.991 0.991 0.991z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.47a9e0a4514f94eda56e0cfd1e3d79ac.svg";
export { ForwardRef as ReactComponent };